import { ThemeConfigurationService } from './core/services/theme-configuration.service';
import { LoggedInUserService } from 'src/app/core/services/loggedInUser/logged-in-user.service';
import { Component, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit, OnInit, OnDestroy {
  title = 'BACKEND-EMPRESAS';
  arrayThemes = [];

  constructor(
    private spinner: NgxSpinnerService,
    private themeService: ThemeConfigurationService,
    private translate: TranslateService,
    private loggedInUserService: LoggedInUserService,
  ) {
    // this.spinner.show();
    this.translate.setDefaultLang('es');
  }

  ngOnInit() {
    this.gertTheme();
  }

  ngAfterViewInit() {}

  gertTheme() {
    let themeColor = +localStorage.getItem('themeColor') || 0;
    let arrayThemes = this.themeService.ListThemes;
    let theme = arrayThemes[themeColor];
    this.themeService.selectedTheme = theme;
    document.getElementById('bodyAppId').className = theme.className + ' mat-typography';
    localStorage.setItem('themeColor', theme.id);
  }

  ngOnDestroy() {}
}
